import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    diagram: Object,
    operationId: Number
  }

  connect() {
    this.renderReactFlow()
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
    }
  }

  renderReactFlow() {
    const BlastRadiusCanvas = window.BlastRadiusCanvas
    const React = window.React
    const createRoot = window.createRoot

    if (!BlastRadiusCanvas || !React || !createRoot) {
      console.error("React components not loaded")
      this.renderFallback()
      return
    }

    const diagram = this.diagramValue || { nodes: [], edges: [] }

    this.root = createRoot(this.element)
    this.root.render(
      React.createElement(BlastRadiusCanvas, {
        diagram: diagram,
        operationId: this.operationIdValue
      })
    )
  }

  renderFallback() {
    // Fallback if React components aren't loaded
    const diagram = this.diagramValue || { nodes: [], edges: [] }
    this.element.innerHTML = `
      <div class="p-4 text-center text-slate-500">
        <p>Graph visualization requires JavaScript.</p>
        <p class="text-sm mt-2">${diagram.nodes?.length || 0} nodes, ${diagram.edges?.length || 0} edges</p>
      </div>
    `
  }
}
